module.exports = new __parcel__URL__("key_technologies_1.26a8de48.jpg").toString();